import { TranscriptionBlockData } from './transcription.types';

type TranscriptionWordPayload = {
  start: number;
  end: number;
  word: string;
  confidence: number;
};

/**
 * Flattens transcript blocks into the API word list, applying a single text edit by word id.
 */
export function buildTranscriptionWordsPayload(
  blocks: TranscriptionBlockData[],
  editedWordId: string,
  newText: string,
): TranscriptionWordPayload[] {
  return blocks.flatMap((block) =>
    block.words.map((word) => ({
      start: word.start,
      end: word.end,
      word: word.id === editedWordId ? newText : word.text,
      confidence: word.confidence,
    })),
  );
}
